export const MAIN_HRA_SURVEYID = 'main-hra-survey';
export const AWS_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss.sss[Z]';
export const SSN_EXP = /^(?!(000|666|9))\d{3}-(?!00)\d{2}-(?!0000)\d{4}$|^(?!(000|666|9))\d{3}(?!00)\d{2}(?!0000)\d{4}$/;
